import { Component, ContentChild, ViewChild, TemplateRef, forwardRef } from '@angular/core';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';

@Component({
    providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => ToolbarItemComponent) }],
    selector: 'app-toolbar-item',
    template: `
    <ng-template kendoToolBarTemplate #toolbarTemplate>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-template>
  `,
    standalone: false
})
export class ToolbarItemComponent extends ToolBarToolComponent {
    @ContentChild(TemplateRef) content!: TemplateRef<any>;
    @ViewChild('toolbarTemplate', { static: true }) public declare toolbarTemplate: TemplateRef<any>;
    public tabindex = -1;
    constructor() {
        super();
    }
} 